<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Detalle de reporte de servicios</title>
</head>
<body>
<div class="report-container">
  <h1>Detalle de reporte de servicios</h1>
  <form>
    <div class="form-group">
      <button class="btn btn-outline-success font-weight-bold" type="submit"
              (click)="this.goBack()">Regresar
      </button>
    </div>
    <div class="form-group">
      <button class="btn btn-outline-success font-weight-bold" type="button" (click)="this.downloadReport()">Generar
        Reporte
      </button>
    </div>
  </form>
  <div class="table-responsive mt-2 mb-2 ">
    <table>
      <thead>
      <tr>
        <th>#</th>
        <th>Año</th>
        <th>Mes</th>
        <th>Partner</th>
        <th>Empresa</th>
        <th>Flujo</th>
        <th>Asunto</th>
        <th>Fecha de carga</th>
        <th>Tipo de firma</th>
        <th>Firmante</th>
        <th>Fecha de firma</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let totalServiceReportDetail of totalServiceReportDetails; let index=index">
        <td title="#">{{index + 1}}</td>
        <td title="{{'TABLE.HEADER.YEAR' | translate }}">{{totalServiceReportDetail.year}}</td>
        <td title="{{'TABLE.HEADER.MONTH' | translate }}">{{this.getMonth(totalServiceReportDetail.month)}}</td>
        <td title="{{'TABLE.HEADER.PARTNER' | translate }}">{{totalServiceReportDetail.partner}}</td>
        <td title="{{'TABLE.HEADER.ENTERPRISE' | translate }}">{{totalServiceReportDetail.enterprise}}</td>
        <td title="{{'TABLE.HEADER.WORKFLOW' | translate }}">{{totalServiceReportDetail.workflow}}</td>
        <td title="{{'TABLE.HEADER.SUBJECT' | translate }}">{{totalServiceReportDetail.subject}}</td>
        <td title="{{'TABLE.HEADER.LOAD-DATE' | translate }}">{{totalServiceReportDetail.dateUpload}}</td>
        <td title="{{'TABLE.HEADER.TYPE-SIGNATURE' | translate }}">{{totalServiceReportDetail.typeSignature}}</td>
        <td title="{{'TABLE.HEADER.SIGNER' | translate }}">{{totalServiceReportDetail.signer}}</td>
        <td title="{{'TABLE.HEADER.SIGNER-DATE' | translate }}">{{totalServiceReportDetail.dateSign}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
</body>
</html>
<app-loading *ngIf="loading"></app-loading>
